import React, { ReactNode, useContext } from 'react';
import { StyleProp, StyleSheet, TouchableHighlight, View } from 'react-native';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  children,
  variant,
  kind = 'button',
  size,
  // ToDo: Implement Reverse logic
  reverse = false,
  disabled,
  // ToDo : Do we need this ?
  onClick,
  style,
}: {
  children?: ReactNode;
  onClick: any;
  kind?: 'button' | 'icon' | 'wide';
  variant?: 'danger' | 'ghost' | 'primary' | 'secondary';
  size?: 'lg' | 'md' | 'sm' | 'xl';
  reverse?: boolean;
  disabled?: boolean;
  style?: StyleProp<any>;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  let buttonColor = colors.brand[300];
  let buttonUnderlayColor = colors.brand[500];
  let buttonSize = 50;
  switch (size) {
    case 'sm':
      buttonSize = 25;
      break;
    case 'lg':
      buttonSize = 150;
      break;
    case 'xl':
      buttonSize = 200;
      break;
  }
  switch (variant) {
    case 'primary':
      buttonColor = colors.brand[500];
      buttonUnderlayColor = colors.brand[700];
      break;
    case 'secondary':
      buttonColor = colors.background[700];
      buttonUnderlayColor = colors.background[900];
      break;
    case 'ghost':
      buttonColor = colors.warning;
      buttonUnderlayColor = colors.warning;
      break;
    case 'danger':
      buttonColor = colors.danger;
      buttonUnderlayColor = colors.danger;
      break;
  }

  const styles = StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      backgroundColor: buttonColor,
      height: buttonSize,
      width: kind === 'wide' ? '100%' : buttonSize * 2,
      ...style,
    },
  });

  return (
    <TouchableHighlight
      underlayColor={buttonUnderlayColor}
      disabled={disabled}
      style={styles.container}
      onPress={onClick}
    >
      <View>{!reverse && children}</View>
      {/* {reverse && Some component here} */}
    </TouchableHighlight>
  );
}
